(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recent-purchase-toast"] && !Shopify.designMode) return;
  try {
    
  class RecentPurchaseToast extends HTMLElement {
    connectedCallback() {
      this.closeButton = this.querySelector('[data-recent-purchase-close]');
      this.closeButton?.addEventListener('click', this.hideToast);

      if (sessionStorage.getItem('cds-recent-purchase-dismissed') === 'true') return;

      this.showTimer = window.setTimeout(this.showToast, Number(this.dataset.showDelay) || 5000);
    }

    disconnectedCallback() {
      this.closeButton?.removeEventListener('click', this.hideToast);
      window.clearTimeout(this.showTimer);
      window.clearTimeout(this.hideTimer);
    }

    showToast = () => {
      this.hidden = false;
      requestAnimationFrame(() => this.classList.add('is-visible'));
      this.hideTimer = window.setTimeout(this.hideToast, Number(this.dataset.visibleDuration) || 12000);
    };

    hideToast = () => {
      this.classList.remove('is-visible');
      sessionStorage.setItem('cds-recent-purchase-dismissed', 'true');
      window.setTimeout(() => {
        this.hidden = true;
      }, 200);
    };
  }

  if (!customElements.get('recent-purchase-toast')) {
    customElements.define('recent-purchase-toast', RecentPurchaseToast);
  }

  } catch(e) { console.error(e); }
})();
})();
